<template>
    <SignupLayout>
        <NsHeader slot="header" />
        <nuxt slot="app" />
        <NsFooter slot="footer" />
    </SignupLayout>
</template>

<script>
import {NsHeader, NsFooter} from '@nuskin/app-components';
import SignupLayout from '~/components/SignupLayout.vue';

export default {
    components: {
        NsHeader,
        NsFooter,
        SignupLayout
    }
};
</script>
